import { api } from 'api/common'
import { createActionsHook } from 'react-redux-actions-hook'
import { setToastMessage, setBusy } from '../../components/app/actions'
import { AuthActionType } from './constants'
import {
    USER_LOGIN_URL,
    GOOGLE_LOGIN_URL,
    USER_REGISTER_URL,
    ME_USER_URL,
    USER_LOGOUT_URL,
    PROCESS_INVITE,
    CHECK_INVITE,
    LOAD_INVITE,
    RESET_PASSWORD,
    REQUEST_RESET_PWD,
    RESEND_VERIFICATION,
    VERIFY_EMAIL,
    VERIFY_2FA,
    SEND_EMAIL_OTP,
    GET_LOGGED_IN_USER_DETAILS,
} from 'api/constants'
import { logActivity } from "pages/Dashboard/HomeSevenScreen/7screen/redux/api/loggingAPI";
import { UserActivityConstants } from "api/UserActivityConstants";
import { AppRouteURI } from '../../router/RoleBasedAccess'
import { push } from 'connected-react-router'
import { UNAUTHORIZED_USER_RESPONSE } from './constants'

export const sendEmailOTP = (email) => {
    return (dispatch) => {
        api(
            SEND_EMAIL_OTP,
            { method: 'POST', body: JSON.stringify({ email }) },
            dispatch,
        )
            .then(() => {
                dispatch(
                    setToastMessage({
                        message: 'OTP sent to registered email',
                        type: 'success',
                    }),
                )
            })
            .catch((error) => {
                dispatch(
                    setToastMessage({
                        message: error.message,
                        type: 'error',
                    }),
                )
            })
    }
}

export const processOTP = (email, otp, type) => {
    return (dispatch) => {
        api(
            VERIFY_2FA,
            {
                method: 'POST',
                body: JSON.stringify({ email, otp, type }),
            },
            dispatch,
        )
            .then(() => {
                dispatch(loadMe())
                dispatch(setAuthState(true))
            })
            .catch((error) => {
                if (error.message === UNAUTHORIZED_USER_RESPONSE) {
                    dispatch({
                        type: AuthActionType.AUTH_ERROR,
                        payload: { error: true },
                    })
                }
                dispatch(
                    setToastMessage({
                        message:
                            error.message !== UNAUTHORIZED_USER_RESPONSE
                                ? error.message
                                : '',
                        type:
                            error.message !== UNAUTHORIZED_USER_RESPONSE
                                ? 'error'
                                : '',
                    }),
                )
            })
    }
}

export const setupTwoFactorAuth = (email, required, verified) => {
    return {
        type: AuthActionType.SET_TWO_FACTOR_AUTH,
        email,
        verified,
        required,
    }
}

export const checkAuthentication = () => {
    return (dispatch) => {
        dispatch(setFetching(true))
        api(ME_USER_URL, {}, dispatch)
            .then((data) => {
                dispatch(setAuthState(data.authenticated))
            })
            .catch((error) => {
                console.error(error)
            })
            .finally(() => {
                logActivity({
                    screen : UserActivityConstants.HOME_SCREEN,
                    action_type :  UserActivityConstants.ACTION_TYPES.LOGIN,
                    action : UserActivityConstants.COMMON_ACTIONS.LOGIN,
                    action_target : 'login'
                  }); 
                dispatch(setFetching(false))
            })
    }
}

export const setAuthState = (loggedIn) => {
    return { type: AuthActionType.SET_AUTH, loggedIn }
}

export const setRole = ({ role }) => {
    return { type: AuthActionType.SET_ROLE, role }
}

export const setGuser = ({ role }) => {
    return { type: AuthActionType.SET_GUSER, role }
}

export const setFetching = (fetching) => {
    return { type: AuthActionType.SET_FETCHING, fetching }
}

export const setRegistration = (register) => {
    return { type: AuthActionType.SET_REGISTRATION, register }
}

export const setInviteData = (data) => {
    return { type: AuthActionType.SET_INVITE_DATA, data }
}
export const resetData = () => {
    return { type: AuthActionType.RESET_DATA }
}


export const login = (email, password) => {
    return (dispatch) => {
        api(
            USER_LOGIN_URL,
            {
                method: 'POST',
                body: JSON.stringify({ email, password }),
            },
            dispatch,
        )
            .then(() => {
                dispatch(loadMe())
                dispatch(setAuthState(true))
            })
            .catch((error) => {
                if (error.require_2fa && !error.verified_2fa) {
                    dispatch(setupTwoFactorAuth(email, true, false))
                    dispatch(push(AppRouteURI.TWO_FACTOR))
                }
                if (!error.active) {
                    dispatch(
                        setToastMessage({
                            message: 'Account is inactive. Please contact admin',
                            type: 'error',
                        }),
                    )
                } else if (!error.authenticated) {
                    dispatch(
                        setToastMessage({
                            message: "Invalid email or password",
                            type: 'error',
                        }),
                    )
                }
                else if (!error.email_verified) {
                    dispatch({
                        type: AuthActionType.AUTH_ERROR,
                        payload: { error: true },
                    })
                }
            })
    }
}

export const googleLogin = (data) => {
    return (dispatch) => {
        api(
            GOOGLE_LOGIN_URL,
            {
                method: 'POST',
                body: JSON.stringify(data),
            },
            dispatch,
        )
            .then((res) => {
                dispatch(loadMe())
                dispatch(setAuthState(res.authenticated))
                dispatch(setGuser(true))
                dispatch(
                    setToastMessage({
                        message: 'Logged in through google successfully',
                        type: 'success',
                    }),
                )
            })
            .catch((error) => {
                //Handle Error
            })
    }
}

export const register = (registrationInfo) => {
    const data = { ...registrationInfo }
    delete data.role
    return (dispatch) => {
        api(
            USER_REGISTER_URL,
            {
                method: 'POST',
                body: JSON.stringify(data),
            },
            dispatch,
        )
            .then((res) => {
                if (res && res.user_id) {
                    dispatch(
                        setToastMessage({
                            message: res.message,
                            type: 'success',
                        }),
                    )
                    dispatch(push(AppRouteURI.LOGIN))
                } else {
                    dispatch(
                        setToastMessage({
                            message: "Something went wrong. Please try again",
                            type: 'error',
                        }),
                    )
                }
            })
            .catch((error) => {
                //Handle Error
            })
    }
}

export const processInvite = (data) => {
    return (dispatch, stateFn) => {
        const { query } = stateFn().router.location
        api(
            PROCESS_INVITE,
            {
                method: 'POST',
                body: JSON.stringify({ ...data, ...query }),
            },
            dispatch,
        )
            .then(() => {
                dispatch(
                    setToastMessage({
                        message: 'Successfully registered',
                        type: 'success',
                    }),
                )
                dispatch(push(AppRouteURI.LOGIN))
            })
            .catch((error) => {
                //Handle Error
            })
    }
}

export const loadMe = () => {
    return (dispatch) => {
        dispatch(setFetching(true))
        api(ME_USER_URL, {}, dispatch)
            .then((data) => {
                dispatch(setAuthState(data.authenticated))
                if (data.authenticated) {
                    dispatch(loadUserDetails())
                    dispatch(setRole(data))
                }
            })
            .catch((error) => {
                console.error(error)
            })
            .finally(() => {
                dispatch(setFetching(false))
            })
    }
}

export const logout = () => {
    return (dispatch) => {
        api(USER_LOGOUT_URL, {}, dispatch)
            .then((data) => {
                dispatch(setAuthState(data.authenticated))
                dispatch(push(AppRouteURI.LOGIN))
            })
            .catch((error) => {
                //Handle Error
            })
    }
}

export const resendVerification = (email) => {
    return (dispatch) => {
        api(
            RESEND_VERIFICATION,
            {
                method: 'POST',
                body: JSON.stringify({ email }),
            },
            dispatch,
        )
            .then(() => {
                dispatch(
                    setToastMessage({
                        message: 'Verification email sent',
                        type: 'success',
                    }),
                )
            })
            .catch((error) => {
                //Handle Error
            })
    }
}

export const showToast = (message, type) => {
    return (dispatch) => {
        dispatch(
            setToastMessage({
                message,
                type,
            }),
        )
    }
}

export const verifyEmail = (token) => {
    return (dispatch) => {
        api(
            `${VERIFY_EMAIL}/${token}`,
            {
                method: 'GET',
            },
            dispatch,
        )
            .then((res) => {
                dispatch({
                    type: AuthActionType.SET_VERIFIED,
                    payload: { verified: res.verified },
                })
                dispatch(
                    setToastMessage({
                        message: 'Email verified successfully',
                        type: 'success',
                    }),
                )
            })
            .catch((error) => {
                //Handle Error
                dispatch(
                    setToastMessage({
                        message: error.message,
                        type: 'error',
                    }),
                )
            })
    }
}

export const checkInvite = () => {
    return (dispatch, stateFn) => {
        const { location } = stateFn().router
        const { query } = location
        const { token } = query
        api(
            CHECK_INVITE,
            {
                method: 'POST',
                body: JSON.stringify({ token }),
            },
            dispatch,
        )
            .then((res) => {
                dispatch(
                    setToastMessage({
                        message: res.message,
                        type: 'success',
                    }),
                )
            })
            .catch((error) => {
                dispatch(
                    setToastMessage({
                        message: error.message || 'Invalid Invite',
                        type: 'error',
                    }),
                )
            })
    }
}

export const loadInviteDetails = () => {
    return (dispatch, stateFn) => {
        const { location } = stateFn().router
        const { query } = location
        const { token } = query
        if (!token) {
            dispatch(push(AppRouteURI.HOME))
        }
        api(
            `${LOAD_INVITE}/${token}`,
            {
                method: 'GET',
            },
            dispatch,
        )
            .then(({ data }) => {
                dispatch(setInviteData(data))
            })
            .catch((error) => {
                dispatch(push(AppRouteURI.HOME))
            })
    }
}

export const resetPasswordWithToken = (new_password) => {
    return (dispatch, stateFn) => {
        const { location } = stateFn().router
        const { query } = location
        const { token } = query
        if (!token) {
            dispatch(push(AppRouteURI.HOME))
        }
        api(
            `${RESET_PASSWORD}`,
            {
                method: 'POST',
                body: JSON.stringify({ token, new_password }),
            },
            dispatch,
        )
            .then((res) => {
                dispatch(
                    setToastMessage({
                        message: res.message || 'Reset Successful',
                        type: 'success',
                    }),
                )
                if (res.success) {
                    dispatch(push(AppRouteURI.LOGIN))
                }
            })
            .catch((error) => {
                //do nothing
            })
    }
}

export const requestResetPassword = (email) => {
    return (dispatch) => {
        api(
            `${REQUEST_RESET_PWD}`,
            {
                method: 'POST',
                body: JSON.stringify({
                    "email": email.trim().toLowerCase()
                }),
            },
            dispatch,
        )
            .then((res) => {
                dispatch(
                    setToastMessage({
                        message: res.message || 'Email Sent',
                        type: 'success',
                    }),
                )
            })
            .catch((error) => {
                //do nothing
            })
    }
}

export const renderVerificationMessage = (show) => {
    return (dispatch) => {
        dispatch({
            type: AuthActionType.AUTH_ERROR,
            payload: { error: show },
        })
    }
}

export const loadUserDetails = () => {
    return (dispatch) => {
        api(
            GET_LOGGED_IN_USER_DETAILS,
            {
                method: 'GET',
            },
            dispatch,
        )
            .then((res) => {
                dispatch({
                    type: AuthActionType.SET_USER_DATA,
                    user: res,
                })
            })
            .catch((error) => {
                console.log(error)
            })
    }
}


export default createActionsHook({
    checkAuthentication,
    loadMe,
    logout,
    verifyEmail,
    showToast,
    resendVerification,
    renderVerificationMessage,
    register,
    googleLogin,
    login,
    processInvite,
    setRegistration,
    checkInvite,
    loadInviteDetails,
    resetPasswordWithToken,
    requestResetPassword,
    processOTP,
    sendEmailOTP,
    setupTwoFactorAuth,
    resetData
})
